import React, { Component } from "react";
import { Modal } from "antd";
import PrintComponent from "../components/print";
import Resources from "../scripts/resources";

class PrintView extends Component {
  render() {
    const { data, onClose, visible } = this.props;
    return (
      <Modal
        title={Resources.print}
        visible={visible}
        onCancel={onClose}
        footer={false}
        width={500}
      >
        <PrintComponent printDetail={data} />
      </Modal>
    );
  }
}

export default PrintView;
